(function () {
  'use strict';

  /*
    Livvewell Support Finder V2
    ---------------------------------
    Entirely local recommendation engine.
    No OpenAI. No external AI. No matching metafields. No product tags.
  */

  if (window.LivvewellHelpbotV2 && window.LivvewellHelpbotV2.__loaded) {
    return;
  }

  var API = window.LivvewellHelpbotV2 || {};
  API.__loaded = true;
  window.LivvewellHelpbotV2 = API;
  window.LivvewellHelpbot = API;

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function splitLines(value) {
    return String(value || '')
      .split(/\n|\r|\||;/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  var STOP_WORDS = {
    a:1, about:1, an:1, and:1, are:1, as:1, at:1, be:1, because:1,
    been:1, being:1, but:1, by:1, can:1, could:1, do:1, does:1, doing:1,
    for:1, from:1, get:1, gets:1, getting:1, had:1, has:1, have:1, having:1,
    he:1, her:1, hers:1, him:1, his:1, i:1, if:1, im:1, in:1, into:1,
    is:1, it:1, its:1, just:1, me:1, my:1, of:1, on:1, or:1, our:1,
    really:1, she:1, so:1, than:1, that:1, the:1, their:1, them:1, then:1,
    there:1, they:1, this:1, to:1, too:1, us:1, very:1, want:1, wants:1,
    was:1, we:1, were:1, what:1, when:1, with:1, would:1, you:1, your:1,
    baby:1, babies:1, child:1, children:1, kid:1, kids:1,
    need:1, needs:1, help:1, helping:1, struggle:1, struggles:1,
    struggling:1, hard:1, difficult:1, problem:1, problems:1
  };

  function stem(token) {
    var t = normalize(token);

    if (t.length > 6 && /ingly$/.test(t)) {
      t = t.slice(0, -5);
    } else if (t.length > 5 && /ing$/.test(t)) {
      t = t.slice(0, -3);
    } else if (t.length > 5 && /ies$/.test(t)) {
      t = t.slice(0, -3) + 'y';
    } else if (t.length > 4 && /ed$/.test(t)) {
      t = t.slice(0, -2);
    } else if (t.length > 4 && /es$/.test(t)) {
      t = t.slice(0, -2);
    } else if (t.length > 4 && /s$/.test(t)) {
      t = t.slice(0, -1);
    }

    return t;
  }

  function rawTokens(value) {
    return normalize(value)
      .split(' ')
      .map(stem)
      .filter(function (token) {
        return token && token.length >= 2 && !STOP_WORDS[token];
      });
  }

  function uniqueTokens(value) {
    var seen = {};
    var out = [];

    rawTokens(value).forEach(function (token) {
      if (seen[token]) return;
      seen[token] = true;
      out.push(token);
    });

    return out;
  }

  function frequencyMap(list) {
    var map = {};
    list.forEach(function (token) {
      map[token] = (map[token] || 0) + 1;
    });
    return map;
  }

  function includesPhrase(text, phrase) {
    var haystack = normalize(text);
    var needle = normalize(phrase);
    return !!needle && haystack.indexOf(needle) !== -1;
  }

  /*
    Global language knowledge only.
    These are NOT product mappings. They simply translate the language
    customers use into related vocabulary the catalog may use.
  */
  var CONCEPTS = [
    {
      key:'feeding', label:'feeding',
      detect:['feed','feeding','feeds','bottle','bottle feeding','nursing','nurse','breastfeed','breastfeeding','latch','latching','milk'],
      expand:['feed','feeding','nursing','nurse','bottle','breastfeeding','latch','milk']
    },
    {
      key:'pumping', label:'pumping',
      detect:['pump','pumping','breast pump','express','expressing','express milk','milk expression'],
      expand:['pump','pumping','express','expressing','milk','feeding','wearable']
    },
    {
      key:'sleep', label:'sleep',
      detect:['sleep','sleeping','bedtime','nap','naps','crib','cot','night','overnight'],
      expand:['sleep','sleeping','bedtime','nap','soothing','settling']
    },
    {
      key:'settling', label:'settling',
      detect:['settle','settling','soothe','soothing','pat','patting','tap','tapping','rock','rocking','bounce','bouncing','hold to sleep','held to sleep','only sleeps with me','wakes when i leave'],
      expand:['settle','settling','soothe','soothing','pat','patting','rock','rocking','sleep','bedtime']
    },
    {
      key:'wakeups', label:'frequent wake-ups',
      detect:['wake','wakes','waking','wake up','wakes up','keeps waking','frequent wake ups','frequent wakeups','every hour'],
      expand:['wake','waking','sleep','settling','night']
    },
    {
      key:'reflux', label:'reflux or colic',
      detect:['reflux','colic','spit up','spitting up','gassy','gas','burp','burping','uncomfortable after feeding','uncomfortable after feeds','after feeds'],
      expand:['reflux','colic','comfort','feeding','gas','burp']
    },
    {
      key:'swaddle', label:'swaddling',
      detect:['swaddle','swaddling','wont stay swaddled','won\'t stay swaddled','kicks blanket','kick out','arms out','blanket off'],
      expand:['swaddle','swaddling','sleep','comfort','blanket']
    },
    {
      key:'pregnancy', label:'pregnancy comfort',
      detect:['pregnant','pregnancy','maternity','pregnancy sleep','pregnancy discomfort','pregnancy pain','pregnant sleep','bump'],
      expand:['pregnancy','pregnant','maternity','comfort','sleep']
    },
    {
      key:'travel', label:'on-the-go routines',
      detect:['travel','travelling','traveling','trip','flight','flying','on the go','out of the house','outdoors','car ride','road trip'],
      expand:['travel','travelling','on the go','outdoors','portable','compact']
    },
    {
      key:'tummy', label:'tummy time',
      detect:['tummy time','tummy','floor time','play mat','playmat'],
      expand:['tummy','tummy time','development','play','floor']
    },
    {
      key:'headshape', label:'head shape',
      detect:['flat head','head shape','headshape','flat spot','flat spot on head'],
      expand:['flat head','head shape','head support','comfort']
    },
    {
      key:'carrying', label:'carrying',
      detect:['carry','carrying','carrier','hands free carry','wear baby','babywearing'],
      expand:['carry','carrying','carrier','wearable','travel','on the go']
    },
    {
      key:'swim', label:'swimming',
      detect:['swim','swimming','pool','beach','water'],
      expand:['swim','swimming','water','outdoors']
    },
    {
      key:'potty', label:'potty training',
      detect:['potty','potty training','toilet training','toilet'],
      expand:['potty','toilet','training']
    },
    {
      key:'oral', label:'oral care',
      detect:['teeth','tooth','toothbrush','brush teeth','oral care','dental','gums'],
      expand:['tooth','toothbrush','oral','dental','brush','gum']
    },
    {
      key:'clothing', label:'clothing and fit',
      detect:['shirt','leggings','clothes','clothing','wear','outfit','fit','size'],
      expand:['shirt','leggings','clothing','wear','fit','size']
    }
  ];

  function detectedConcepts(query) {
    return CONCEPTS.filter(function (concept) {
      return concept.detect.some(function (phrase) {
        return includesPhrase(query, phrase);
      });
    });
  }

  function queryModel(query) {
    var original = uniqueTokens(query);
    var concepts = detectedConcepts(query);
    var weighted = {};

    original.forEach(function (token) {
      weighted[token] = Math.max(weighted[token] || 0, 2.15);
    });

    concepts.forEach(function (concept) {
      concept.expand.forEach(function (phrase) {
        uniqueTokens(phrase).forEach(function (token) {
          weighted[token] = Math.max(weighted[token] || 0, 1.05);
        });
      });
    });

    return {
      normalized: normalize(query),
      originalTokens: original,
      weightedTokens: weighted,
      concepts: concepts
    };
  }

  function Helpbot(root) {
    this.root = root;
    this.launcher = qs(root, '[data-lw-helpbot-launcher]');
    this.backdrop = qs(root, '[data-lw-helpbot-backdrop]');
    this.panel = qs(root, '[data-lw-helpbot-panel]');
    this.closeButton = qs(root, '[data-lw-helpbot-close]');
    this.resetButton = qs(root, '[data-lw-helpbot-reset]');
    this.conversation = qs(root, '[data-lw-helpbot-conversation]');
    this.welcome = qs(root, '[data-lw-helpbot-welcome]');
    this.messages = qs(root, '[data-lw-helpbot-messages]');
    this.form = qs(root, '[data-lw-helpbot-form]');
    this.input = qs(root, '[data-lw-helpbot-input]');
    this.thinking = qs(root, '[data-lw-helpbot-thinking]');

    this.maxResults = parseInt(root.dataset.maxResults || '3', 10);
    this.minScore = parseFloat(root.dataset.minScore || '4');
    this.safetyEnabled = root.dataset.safetyEnabled !== 'false';
    this.directAddEnabled = root.dataset.directAdd !== 'false';
    this.debug = root.dataset.debug === 'true';

    this.copy = this.readCopy();
    this.products = this.readCatalog();
    this.index = this.buildIndex(this.products);

    this.lastFocus = null;
    this.lastQuery = '';
    this.pendingTimer = null;

    this.bind();

    if (this.debug) {
      console.info('[Livvewell Helpbot V2] Indexed products:', this.products.length, this.products);
    }
  }

  Helpbot.prototype.readCopy = function () {
    var node = qs(this.root, '[data-lw-helpbot-copy]');
    if (!node) return {};

    return {
      resultsEyebrow: node.dataset.resultsEyebrow || '',
      resultsHeading: node.dataset.resultsHeading || '',
      resultsText: node.dataset.resultsText || '',
      noMatchHeading: node.dataset.noMatchHeading || '',
      noMatchText: node.dataset.noMatchText || '',
      safetyHeading: node.dataset.safetyHeading || '',
      safetyText: node.dataset.safetyText || '',
      safetyTerms: splitLines(node.dataset.safetyTerms || ''),
      viewLabel: node.dataset.viewLabel || 'View product',
      addLabel: node.dataset.addLabel || 'Add to cart',
      chooseLabel: node.dataset.chooseLabel || 'Choose options',
      addedLabel: node.dataset.addedLabel || 'Added',
      errorLabel: node.dataset.errorLabel || 'Try again'
    };
  };

  Helpbot.prototype.readCatalog = function () {
    var node = qs(this.root, '[data-lw-helpbot-catalog]');
    if (!node) return [];

    try {
      var parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('[Livvewell Helpbot V2] Could not parse catalog JSON.', error);
      return [];
    }
  };

  Helpbot.prototype.productFields = function (product) {
    return {
      title: String(product.title || ''),
      type: String(product.productType || ''),
      collections: (product.collections || []).join(' '),
      description: String(product.description || ''),
      options: (product.options || []).join(' '),
      variants: (product.variantTitles || []).join(' ')
    };
  };

  Helpbot.prototype.buildIndex = function (products) {
    var fieldNames = ['title','type','collections','description','options','variants'];
    var documentFrequency = {};
    var totals = {};

    fieldNames.forEach(function (field) { totals[field] = 0; });

    var documents = products.map(function (product) {
      var fields = this.productFields(product);
      var docTokens = {};
      var union = {};

      fieldNames.forEach(function (field) {
        var list = rawTokens(fields[field]);
        docTokens[field] = {
          list: list,
          tf: frequencyMap(list),
          length: list.length
        };
        totals[field] += list.length;
        list.forEach(function (token) { union[token] = true; });
      });

      Object.keys(union).forEach(function (token) {
        documentFrequency[token] = (documentFrequency[token] || 0) + 1;
      });

      return {
        product: product,
        fields: fields,
        tokens: docTokens,
        allText: normalize(Object.keys(fields).map(function (key) { return fields[key]; }).join(' '))
      };
    }, this);

    var averages = {};
    fieldNames.forEach(function (field) {
      averages[field] = products.length ? totals[field] / products.length : 1;
      if (!averages[field]) averages[field] = 1;
    });

    return {
      documents: documents,
      df: documentFrequency,
      averages: averages,
      count: products.length || 1
    };
  };

  Helpbot.prototype.idf = function (token) {
    var df = this.index.df[token] || 0;
    var n = this.index.count || 1;
    return Math.log(1 + ((n - df + 0.5) / (df + 0.5)));
  };

  Helpbot.prototype.bm25Term = function (tf, length, avgLength, token) {
    if (!tf) return 0;

    var k1 = 1.25;
    var b = 0.72;
    var denominator = tf + k1 * (1 - b + b * (length / Math.max(avgLength, 1)));
    return this.idf(token) * ((tf * (k1 + 1)) / denominator);
  };

  Helpbot.prototype.conceptBonus = function (model, document) {
    var bonus = 0;
    var matchedConcepts = [];

    model.concepts.forEach(function (concept) {
      var hits = concept.expand.filter(function (phrase) {
        return includesPhrase(document.allText, phrase);
      });

      if (hits.length) {
        bonus += Math.min(4.5, 1.6 + hits.length * 0.65);
        matchedConcepts.push(concept.label);
      }
    });

    return {
      bonus: bonus,
      concepts: matchedConcepts
    };
  };

  Helpbot.prototype.phraseBonus = function (model, document) {
    var bonus = 0;
    var original = model.normalized;

    if (original.length >= 8 && document.allText.indexOf(original) !== -1) {
      bonus += 7;
    }

    var words = normalize(original).split(' ').filter(Boolean);
    for (var i = 0; i < words.length - 1; i++) {
      var pair = words[i] + ' ' + words[i + 1];
      if (pair.length >= 6 && document.allText.indexOf(pair) !== -1) {
        bonus += 1.1;
      }
    }

    return Math.min(bonus, 8.5);
  };

  Helpbot.prototype.scoreDocument = function (query, document) {
    var model = queryModel(query);
    var fieldWeights = {
      title: 5.8,
      type: 4.6,
      collections: 4.0,
      description: 1.45,
      options: 1.65,
      variants: 1.25
    };

    var score = 0;
    var matchedTokens = [];
    var self = this;

    Object.keys(model.weightedTokens).forEach(function (token) {
      var queryWeight = model.weightedTokens[token];
      var tokenMatched = false;

      Object.keys(fieldWeights).forEach(function (field) {
        var tf = document.tokens[field].tf[token] || 0;
        if (!tf) return;

        tokenMatched = true;
        score += queryWeight * fieldWeights[field] * self.bm25Term(
          tf,
          document.tokens[field].length,
          self.index.averages[field],
          token
        );
      });

      if (tokenMatched) matchedTokens.push(token);
    });

    var concept = this.conceptBonus(model, document);
    score += concept.bonus;
    score += this.phraseBonus(model, document);

    /*
      Product title exact-token boost. This matters for users who type a
      product name directly, but doesn't dominate normal concern queries.
    */
    var titleTokens = uniqueTokens(document.fields.title);
    var titleOverlap = model.originalTokens.filter(function (token) {
      return titleTokens.indexOf(token) !== -1;
    }).length;

    if (titleOverlap) score += titleOverlap * 3.4;

    if (!document.product.available) {
      score *= 0.88;
    }

    return {
      product: document.product,
      score: score,
      matchedTokens: matchedTokens,
      matchedConcepts: concept.concepts,
      model: model
    };
  };

  Helpbot.prototype.rankProducts = function (query) {
    var results = this.index.documents
      .map(function (document) {
        return this.scoreDocument(query, document);
      }, this)
      .sort(function (a, b) { return b.score - a.score; });

    if (this.debug) {
      console.groupCollapsed('[Livvewell Helpbot V2] Query: ' + query);
      console.table(results.slice(0, 10).map(function (result) {
        return {
          product_id: result.product.id,
          title: result.product.title,
          score: Number(result.score.toFixed(2)),
          concepts: result.matchedConcepts.join(', '),
          tokens: result.matchedTokens.join(', ')
        };
      }));
      console.groupEnd();
    }

    return results.filter(function (result) {
      return result.score >= this.minScore;
    }, this).slice(0, this.maxResults);
  };

  Helpbot.prototype.bind = function () {
    var self = this;

    if (this.launcher) {
      this.launcher.addEventListener('click', function () { self.open(); });
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', function () { self.close(); });
    }

    if (this.backdrop) {
      this.backdrop.addEventListener('click', function () { self.close(); });
    }

    if (this.resetButton) {
      this.resetButton.addEventListener('click', function () { self.reset(); });
    }

    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        var query = self.input ? self.input.value.trim() : '';
        if (!query) return;
        self.submit(query);
        self.input.value = '';
        self.autoSizeInput();
      });
    }

    if (this.input) {
      this.input.addEventListener('input', function () { self.autoSizeInput(); });
      this.input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
          event.preventDefault();
          if (!self.input.value.trim()) return;
          if (self.form && typeof self.form.requestSubmit === 'function') {
            self.form.requestSubmit();
          } else {
            self.submit(self.input.value.trim());
            self.input.value = '';
            self.autoSizeInput();
          }
        }
      });
    }

    this.root.addEventListener('click', function (event) {
      var queryButton = event.target.closest('[data-lw-helpbot-query]');
      if (queryButton && self.root.contains(queryButton)) {
        var query = queryButton.dataset.lwHelpbotQuery || '';
        if (queryButton.dataset.lwHelpbotFollowup === 'true' && self.lastQuery) {
          query = self.lastQuery + ' ' + query;
        }
        if (query) self.submit(query);
        return;
      }

      var addButton = event.target.closest('[data-lw-helpbot-add]');
      if (addButton && self.root.contains(addButton)) {
        self.addToCart(addButton);
        return;
      }

      var productLink = event.target.closest('[data-lw-helpbot-product-link]');
      if (productLink && self.root.contains(productLink)) {
        self.track('lw_helpbot_product_click', {
          product_id: productLink.dataset.productId || '',
          query: self.lastQuery
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!self.panel || self.panel.hidden) return;
      if (event.key === 'Escape') {
        self.close();
        return;
      }
      if (event.key === 'Tab') self.trapFocus(event);
    });
  };

  Helpbot.prototype.open = function () {
    if (!this.panel || !this.backdrop) return;
    this.lastFocus = document.activeElement;
    this.panel.hidden = false;
    this.backdrop.hidden = false;
    document.body.classList.add('lw-helpbot-open');

    if (this.launcher) {
      this.launcher.setAttribute('aria-expanded', 'true');
      this.launcher.hidden = true;
    }

    var self = this;
    window.requestAnimationFrame(function () {
      if (self.input) self.input.focus();
    });

    this.track('lw_helpbot_open', { engine_version: 2 });
  };

  Helpbot.prototype.close = function () {
    if (!this.panel || !this.backdrop) return;
    this.panel.hidden = true;
    this.backdrop.hidden = true;
    document.body.classList.remove('lw-helpbot-open');

    if (this.launcher) {
      this.launcher.hidden = false;
      this.launcher.setAttribute('aria-expanded', 'false');
    }

    if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      this.lastFocus.focus();
    }

    this.track('lw_helpbot_close', { engine_version: 2 });
  };

  Helpbot.prototype.reset = function () {
    if (this.pendingTimer) {
      window.clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
    }

    if (this.messages) this.messages.innerHTML = '';
    if (this.thinking) this.thinking.hidden = true;
    this.lastQuery = '';
    if (this.welcome) this.welcome.hidden = false;

    if (this.input) {
      this.input.value = '';
      this.autoSizeInput();
      this.input.focus();
    }

    if (this.conversation) this.conversation.scrollTop = 0;
    this.track('lw_helpbot_reset', { engine_version: 2 });
  };

  Helpbot.prototype.autoSizeInput = function () {
    if (!this.input) return;
    this.input.style.height = 'auto';
    this.input.style.height = Math.min(this.input.scrollHeight, 92) + 'px';
  };

  Helpbot.prototype.submit = function (query) {
    var self = this;
    if (!query) return;

    if (this.pendingTimer) window.clearTimeout(this.pendingTimer);
    this.lastQuery = query;
    if (this.welcome) this.welcome.hidden = true;
    this.appendUserMessage(query);
    if (this.thinking) this.thinking.hidden = false;
    this.scrollBottom();

    this.track('lw_helpbot_query', {
      query: query,
      engine_version: 2
    });

    this.pendingTimer = window.setTimeout(function () {
      self.pendingTimer = null;
      if (self.thinking) self.thinking.hidden = true;

      if (self.isSafetyQuery(query)) {
        self.appendSafetyResponse();
        self.scrollBottom();
        self.track('lw_helpbot_safety_route', { query: query, engine_version: 2 });
        return;
      }

      if (!self.products.length) {
        self.appendNoMatch(query, true);
        self.scrollBottom();
        return;
      }

      var results = self.rankProducts(query);

      if (!results.length) {
        self.appendNoMatch(query, false);
        self.scrollBottom();
        self.track('lw_helpbot_no_match', { query: query, engine_version: 2 });
        return;
      }

      self.appendResults(query, results);
      self.scrollBottom();

      self.track('lw_helpbot_results', {
        query: query,
        engine_version: 2,
        product_ids: results.map(function (result) {
          return String(result.product.id);
        })
      });
    }, 320);
  };

  Helpbot.prototype.appendUserMessage = function (query) {
    if (!this.messages) return;
    var wrap = document.createElement('div');
    wrap.className = 'lw-helpbot__message lw-helpbot__message--user';
    wrap.innerHTML = '<div class="lw-helpbot__bubble">' + escapeHTML(query) + '</div>';
    this.messages.appendChild(wrap);
  };

  Helpbot.prototype.isSafetyQuery = function (query) {
    if (!this.safetyEnabled) return false;
    return this.copy.safetyTerms.some(function (phrase) {
      return includesPhrase(query, phrase);
    });
  };

  Helpbot.prototype.appendSafetyResponse = function () {
    if (!this.messages) return;
    var wrap = document.createElement('div');
    wrap.className = 'lw-helpbot__response';
    wrap.innerHTML =
      '<p class="lw-helpbot__result-eyebrow">SUPPORT FIRST</p>' +
      '<h3>' + escapeHTML(this.copy.safetyHeading) + '</h3>' +
      '<p class="lw-helpbot__response-copy">' + escapeHTML(this.copy.safetyText) + '</p>';
    this.messages.appendChild(wrap);
  };

  Helpbot.prototype.appendNoMatch = function (query, emptyCatalog) {
    if (!this.messages) return;
    var wrap = document.createElement('div');
    var copy = emptyCatalog
      ? 'The catalog index is empty. Choose a source collection in the Support Finder section settings.'
      : this.copy.noMatchText;

    wrap.className = 'lw-helpbot__response';
    wrap.innerHTML =
      '<p class="lw-helpbot__result-eyebrow">LET\'S NARROW IT DOWN</p>' +
      '<h3>' + escapeHTML(this.copy.noMatchHeading) + '</h3>' +
      '<p class="lw-helpbot__response-copy">' + escapeHTML(copy) + '</p>' +
      this.followupMarkup(this.followupsFor(query));
    this.messages.appendChild(wrap);
  };

  Helpbot.prototype.resultContext = function (result) {
    var labels = (result.matchedConcepts || []).slice(0, 2);
    if (labels.length) return labels.join(' + ');

    var type = result.product.productType || '';
    if (type) return type;

    var collections = result.product.collections || [];
    return collections.length ? collections[0] : '';
  };

  Helpbot.prototype.productSummary = function (product) {
    var text = String(product.description || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    if (text.length <= 150) return text;
    return text.slice(0, 147).replace(/\s+\S*$/, '') + '...';
  };

  Helpbot.prototype.appendResults = function (query, results) {
    if (!this.messages) return;
    var wrap = document.createElement('div');
    var cards = '';
    var self = this;

    results.forEach(function (result) {
      cards += self.productMarkup(result);
    });

    var concepts = detectedConcepts(query).map(function (concept) { return concept.label; });
    var context = concepts.length
      ? '<p class="lw-helpbot__match-note">Matched around <strong>' + escapeHTML(concepts.slice(0, 3).join(', ')) + '</strong>.</p>'
      : '';

    wrap.className = 'lw-helpbot__response';
    wrap.innerHTML =
      '<p class="lw-helpbot__result-eyebrow">' + escapeHTML(this.copy.resultsEyebrow) + '</p>' +
      '<h3>' + escapeHTML(this.copy.resultsHeading) + '</h3>' +
      '<p class="lw-helpbot__response-copy">' + escapeHTML(this.copy.resultsText) + '</p>' +
      context +
      '<div class="lw-helpbot__results">' + cards + '</div>' +
      this.followupMarkup(this.followupsFor(query));

    this.messages.appendChild(wrap);
  };

  Helpbot.prototype.productMarkup = function (result) {
    var product = result.product;
    var image = product.image
      ? '<div class="lw-helpbot__product-image"><img src="' + escapeHTML(product.image) + '" alt="' + escapeHTML(product.title) + '" loading="lazy"></div>'
      : '<div class="lw-helpbot__product-image"></div>';

    var context = this.resultContext(result);
    var summary = this.productSummary(product);
    var compare = product.comparePrice
      ? '<span class="lw-helpbot__compare">' + escapeHTML(product.comparePrice) + '</span>'
      : '';

    var summaryMarkup = summary
      ? '<p class="lw-helpbot__product-summary">' + escapeHTML(summary) + '</p>'
      : '';

    var secondaryAction = '';

    if (this.directAddEnabled && product.directAdd && product.available && product.variantId) {
      secondaryAction =
        '<button type="button" class="lw-helpbot__product-add" data-lw-helpbot-add data-product-id="' + escapeHTML(product.id) + '" data-variant-id="' + escapeHTML(product.variantId) + '">' +
        escapeHTML(this.copy.addLabel) + '</button>';
    } else if (!product.directAdd && product.available) {
      secondaryAction =
        '<a class="lw-helpbot__product-add" href="' + escapeHTML(product.url) + '">' +
        escapeHTML(this.copy.chooseLabel) + '</a>';
    }

    return (
      '<article class="lw-helpbot__product" data-product-id="' + escapeHTML(product.id) + '">' +
        image +
        '<div class="lw-helpbot__product-body">' +
          (context ? '<p class="lw-helpbot__product-concern">' + escapeHTML(context) + '</p>' : '') +
          '<h4 class="lw-helpbot__product-title">' + escapeHTML(product.title) + '</h4>' +
          '<div class="lw-helpbot__price-row"><span class="lw-helpbot__price">' + escapeHTML(product.price) + '</span>' + compare + '</div>' +
          summaryMarkup +
          '<div class="lw-helpbot__product-actions">' +
            '<a class="lw-helpbot__product-link" data-lw-helpbot-product-link data-product-id="' + escapeHTML(product.id) + '" href="' + escapeHTML(product.url) + '">' + escapeHTML(this.copy.viewLabel) + '</a>' +
            secondaryAction +
          '</div>' +
        '</div>' +
      '</article>'
    );
  };

  Helpbot.prototype.followupsFor = function (query) {
    var keys = detectedConcepts(query).map(function (concept) { return concept.key; });

    if (keys.indexOf('feeding') !== -1 && keys.indexOf('pumping') === -1 && keys.indexOf('reflux') === -1) {
      return [
        ['Pumping', 'pumping and expressing milk'],
        ['Nursing / bottle feeding', 'nursing bottle feeding latch'],
        ['Discomfort after feeds', 'reflux colic uncomfortable after feeding'],
        ['Feeding on the go', 'feeding while travelling on the go']
      ];
    }

    if (keys.indexOf('sleep') !== -1 || keys.indexOf('settling') !== -1 || keys.indexOf('wakeups') !== -1) {
      return [
        ['Won\'t settle', 'wont settle needs patting soothing'],
        ['Wakes frequently', 'frequent wake ups waking often'],
        ['Won\'t stay swaddled', 'wont stay swaddled kicks blanket off'],
        ['Travel sleep', 'sleep while travelling on the go']
      ];
    }

    if (keys.indexOf('travel') !== -1) {
      return [
        ['Sleep on the go', 'travel sleep naps'],
        ['Feeding on the go', 'feeding pumping on the go'],
        ['Carrying / outings', 'carrying outdoors travel']
      ];
    }

    return [
      ['Sleep', 'sleep settling bedtime'],
      ['Feeding', 'feeding nursing bottle'],
      ['Comfort', 'comfort reflux colic'],
      ['Pregnancy', 'pregnancy comfort'],
      ['On the go', 'travel outdoors on the go']
    ];
  };

  Helpbot.prototype.followupMarkup = function (items) {
    if (!items || !items.length) return '';
    return '<div class="lw-helpbot__followups">' + items.map(function (item) {
      return '<button type="button" class="lw-helpbot__followup" data-lw-helpbot-query="' + escapeHTML(item[1]) + '" data-lw-helpbot-followup="true">' + escapeHTML(item[0]) + '</button>';
    }).join('') + '</div>';
  };

  Helpbot.prototype.addToCart = function (button) {
    var self = this;
    var variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    var original = button.textContent;
    button.disabled = true;
    button.textContent = '...';

    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    window.fetch(shopRoot + 'cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({
        items:[{
          id:Number(variantId),
          quantity:1,
          properties:{'_livvewell_support_finder':'v2'}
        }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        button.textContent = self.copy.addedLabel;
        button.disabled = false;

        self.track('lw_helpbot_add_to_cart', {
          product_id: button.dataset.productId || '',
          variant_id: variantId,
          query: self.lastQuery,
          engine_version: 2
        });

        window.setTimeout(function () {
          self.close();
          if (window.LivvewellCartDrawer && typeof window.LivvewellCartDrawer.open === 'function') {
            window.LivvewellCartDrawer.open();
          }
        }, 220);
      })
      .catch(function () {
        button.textContent = self.copy.errorLabel;
        window.setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1200);
      });
  };

  Helpbot.prototype.scrollBottom = function () {
    var self = this;
    window.requestAnimationFrame(function () {
      if (self.conversation) self.conversation.scrollTop = self.conversation.scrollHeight;
    });
  };

  Helpbot.prototype.trapFocus = function (event) {
    if (!this.panel) return;
    var focusable = qsa(this.panel, 'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])')
      .filter(function (node) { return !node.hidden && node.offsetParent !== null; });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  Helpbot.prototype.track = function (eventName, detail) {
    var payload = detail || {};

    this.root.dispatchEvent(new CustomEvent(eventName, {
      bubbles:true,
      detail:payload
    }));

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      var dataLayerPayload = { event:eventName };
      Object.keys(payload).forEach(function (key) {
        dataLayerPayload[key] = payload[key];
      });
      window.dataLayer.push(dataLayerPayload);
    }
  };

  function init(root) {
    if (!root || root.dataset.lwHelpbotReady === 'v2') return null;
    root.dataset.lwHelpbotReady = 'v2';
    var instance = new Helpbot(root);
    API.instances = API.instances || [];
    API.instances.push(instance);
    return instance;
  }

  function initAll(scope) {
    qsa(scope || document, '[data-lw-helpbot]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  API.init = init;
  API.initAll = initAll;
})();
